import { debugBus } from './debugBus';
import { randomId } from '../utils/randomId';

export type OrderWorkspaceLogEvent =
  | 'eventLines.fetch_start'
  | 'eventLines.fetch_success'
  | 'eventLines.fetch_timeout'
  | 'eventLines.fetch_abort'
  | 'eventLines.fetch_error'
  | 'eventLines.raw_server_sample'
  | 'eventLines.workspace_snapshot_success'
  | 'eventLines.workspace_snapshot_fallback'
  | 'eventLines.workspace_snapshot_invalid'
  | 'eventLines.inflight_dedupe'
  | 'eventLines.inflight_prune'
  | 'panel.hydration_start'
  | 'panel.hydration_done'
  | 'panel.render_from_cache'
  | 'panel.blocked_cold_load'
  | 'panel.cache_hydrated';

export type OrderWorkspacePanel = 'items' | 'labor' | 'summary';

export type OrderWorkspaceRequestMeta = {
  eventId: string | null;
  usageDate: string | null;
  scope: 'all' | 'date';
  roomKey?: string | null;
  showAllUsageDates?: boolean;
  isSummary?: boolean;
};

export type OrderWorkspaceLogEntry = {
  event: OrderWorkspaceLogEvent;
  correlationId: string;
  panel?: OrderWorkspacePanel;
  request?: OrderWorkspaceRequestMeta;
  durationMs?: number | null;
  rowCount?: number;
  cacheAgeMs?: number | null;
  timeoutMs?: number;
  attempt?: number;
  retry?: number;
  retryDelayMs?: number;
  retryable?: boolean;
  inflightCount?: number;
  inflightCorrelationId?: string;
  correlationIds?: string[];
  inflightMax?: number;
  inflightExpired?: number;
  inflightTrimmed?: number;
  inflightMaxAgeMs?: number;
  errorName?: string;
  errorCode?: string | null;
  errorStatus?: number | null;
  errorMessage?: string;
  blockingQueries?: string[];
  refreshingQueries?: string[];
  source?: string;
  status?: 'success' | 'success_with_zero_rows' | 'canceled' | 'error';
  sample?: unknown;
};

export const createOrderWorkspaceCorrelationId = (prefix: string = 'order-workspace'): string =>
  `${prefix}:${randomId()}`;

export function logOrderWorkspaceEvent(entry: OrderWorkspaceLogEntry, level: 'info' | 'warn' | 'error' = 'info') {
  try {
    debugBus.push({
      channel: 'order-workspace',
      message: entry.event,
      phase: entry.event,
      detail: entry,
      level,
    });
  } catch {
    // ignore logging failures
  }
}
